// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Qo-z","badgeLink":"Ro-z","category":"So-z"};